import React, { Suspense } from 'react';
import { AppRouter } from './AppRouter';
import './index.css';

function App() {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    }>
      <AppRouter />
    </Suspense>
  );
}

export default App;